import { render } from "./EmergencyNumbers.vue?vue&type=template&id=7821218a"
import script from "./EmergencyNumbers.vue?vue&type=script&lang=js"
export * from "./EmergencyNumbers.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__